import React, { useState } from 'react';
import { api } from '../../api/client';
import { miniStyles as S, T } from '../../miniapp/miniStyles';

interface Props {
  /** Bog'langandan keyin — ilovani qaytadan yuklash uchun. */
  onBound: () => void;
}

/**
 * Telegram akkauntini Amanah hisobiga bog'lash.
 *
 * Bu ekran faqat bir marta ko'rinadi: server `telegram_not_linked` qaytarganda.
 * Bog'langandan keyin initData avtomatik ishlaydi — token saqlanmaydi, muddat
 * tugamaydi, qayta login ham yo'q.
 *
 * Parol ATAYLAB faqat shu yerda so'raladi. Kunlik kirish initData orqali:
 * u Telegram tomonidan imzolangan, phishing qilib ham, o'g'irlab ham bo'lmaydi.
 */
export const TelegramBind: React.FC<Props> = ({ onBound }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  const canSubmit = username.trim().length > 0 && password.length > 0 && !saving;

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!canSubmit) return;

    setSaving(true);
    setError('');
    try {
      await api.post('/auth/telegram-bind/', {
        username: username.trim(),
        password,
      });
      onBound();
    } catch (err: any) {
      const data = err?.response?.data || {};
      setError(data.error || data.detail || 'Bog\'lab bo\'lmadi. Qayta urinib ko\'ring.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{ ...S.screen, justifyContent: 'center', padding: 24 }}>
      <form onSubmit={submit} style={{ width: '100%', maxWidth: 360, margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <div style={{ fontSize: 40, marginBottom: 8 }}>🔗</div>
          <div style={{ fontWeight: 800, fontSize: 20, color: T.ink, letterSpacing: -0.3 }}>
            Hisobingizni ulang
          </div>
          <div style={{ fontSize: 14, color: T.inkSub, marginTop: 8, lineHeight: 1.5 }}>
            Bu Telegram akkaunt hali hech qaysi hisobga bog'lanmagan.
            Amanah login va parolingizni bir marta kiriting — keyin
            so'ralmaydi.
          </div>
        </div>

        <input
          style={{ ...S.formInput, width: '100%', boxSizing: 'border-box', fontSize: 16 }}
          placeholder="Login"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          autoCapitalize="none"
          autoCorrect="off"
        />
        <input
          style={{ ...S.formInput, width: '100%', boxSizing: 'border-box', fontSize: 16 }}
          type="password"
          placeholder="Parol"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        {error && (
          <div style={{
            fontSize: 13, color: T.danger, background: T.dangerTint,
            padding: '10px 12px', borderRadius: T.r10, marginBottom: 12,
          }}>
            {error}
          </div>
        )}

        <button
          type="submit"
          disabled={!canSubmit}
          style={{ ...S.confirmBtnBig, ...(canSubmit ? {} : { opacity: 0.5 }) }}
        >
          {saving ? 'Ulanmoqda…' : 'Ulash'}
        </button>

        <div style={{ fontSize: 12, color: T.inkFaint, textAlign: 'center', marginTop: 14, lineHeight: 1.5 }}>
          Login yoki parolni bilmasangiz do'kon egasidan so'rang.
        </div>
      </form>
    </div>
  );
};
